import React from "react";
import { config } from "../Config";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.scss";
import { ImageCountry } from "./CountrySelect";
import { LogoBB } from "../components/LogoBB";

export const ApplicationSwitch = () => {
  return (
    <Navbar.Brand>
      <Link to="/" className="cropfields-dropdown">
        <LogoBB />
        <ImageCountry country={config.bb_country} />
      </Link>
    </Navbar.Brand>
  );
};
